const GetParam = (paramName, location) => {
    const searchParams = new URLSearchParams(location.search);
    const dateString = searchParams.get(paramName);
  return (
    dateString
  )
}

export default GetParam
